/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useNavigate, useParams } from 'react-router';
import { BadgeInfo, CalendarIcon, Check, ChevronLeft, ChevronsUpDown, LoaderCircle } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form'; // Import useForm dan Controller
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { format } from 'date-fns';
import ReactQuill from 'react-quill';
import LayoutAdmin from '../../../components/layouts/LayoutAdmin';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../../../components/ui/breadcrumb';
import Checkbox from '../../../components/ui/checkbox';
import Input from '../../../components/ui/input';
import { Button } from '../../../components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../components/ui/form';
import { Popover, PopoverContent, PopoverTrigger } from '../../../components/ui/popover';
import { Calendar } from '../../../components/ui/calendar';
import cn from '../../../lib/utils';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '../../../components/ui/command';
import { FormSchema } from '../Create/Schema';
import ProductListForm from '../Create/ProductListForm';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../../../components/ui/hover-card';
import usePartner from '../../../stores/usePartner';
import useContact from '../../../stores/useContact';
import 'react-quill/dist/quill.bubble.css';
import { FileUploadSimple } from '../../../components/InputImage';
import useAuth from '../../../stores/useAuth';
import { Dialog, DialogClose, DialogContent, DialogTrigger } from '../../../components/ui/dialog';
import FormPartner from '../../Partner/FormPartner';
import useInvoice from '../../../stores/useInvoice';
import { IInvoice, IInvoiceProduct } from '../../../types/types';
import { useNavigateBack } from '../../../hooks/useNavigateBack';

export default function EditInvoicePage() {
  const { partners, fetchPartner } = usePartner();
  const { contacts, fetchContact } = useContact();
  const navigate = useNavigate();
  const { invoiceId } = useParams();
  const [useCompanyLogo, setUseCompanyLogo] = useState(true);
  const [useCompanySignature, setUseCompanySignature] = useState(false);
  const [selectedPartner, setSelectedPartner] = useState('');
  const { company, dataUser } = useAuth();
  const { loading, updateInvoice, invoice, getInvoice, resetInvoice } = useInvoice();

  const navigateBack = useNavigateBack(`/invoice/view/${invoice?.invoice_id}`);

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      invoice_number: invoice?.invoice_number,
      partner_id: invoice?.partner_id,
      description: invoice?.description,
      subtotal: invoice?.subtotal,
      tax: invoice?.tax,
      total: invoice?.total,
      amount_due: invoice?.amount_due,
      currency: 'rupiah',
      logo: invoice?.logo,
      contact_id: invoice?.contact_id,
      dateRange: {
        from: invoice?.date,
        to: invoice?.due_date,
      },
      invoice_products: invoice?.invoice_products,
      signature: invoice?.signature,
      signature_name: invoice?.signature_name,
    },
  });

  const handleUseCompanyLogo = (checked: boolean) => {
    if (checked) {
      form.setValue('logo', company?.logo as string);
    } else if (!checked) {
      form.setValue('logo', '');
    }
    setUseCompanyLogo(checked);
  };

  const handleUseCompanySignature = (checked: boolean) => {
    if (checked) {
      form.setValue('signature', company?.signature as string);
    } else if (!checked) {
      form.setValue('signature', '');
    }
    setUseCompanySignature(checked);
  };

  async function onSubmit(data: z.infer<typeof FormSchema>) {
    // Transform the form data to match IInvoice structure
    const dataInvoice: IInvoice = {
      invoice_number: data.invoice_number,
      user_id: dataUser?.user_id as string,
      contact_id: data.contact_id || undefined,
      partner_id: data.partner_id,
      logo: data.logo,
      date: data.dateRange.from, // Change dateRange.from to date
      due_date: data.dateRange.to, // Change dateRange.to to due_date
      currency: data.currency,
      description: data.description,
      subtotal: data.subtotal,
      tax: data.tax,
      total: data.total,
      amount_due: data.amount_due,
      signature_name: data.signature_name,
      signature: data.signature,
      invoice_products: data.invoice_products as IInvoiceProduct[],
    };

    try {
      if (!loading) {
        const response = await updateInvoice(invoiceId as string, dataInvoice);
        const { success, message } = response;
        if (!success) {
          throw new Error(message);
        }
        navigate('/invoice');
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (!partners) {
      fetchPartner();
    }
  }, [partners, fetchPartner]);

  useEffect(() => {
    if (!contacts) {
      fetchContact();
    }
  }, [contacts, fetchContact]);

  useEffect(() => {
    form.setValue('contact_id', null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form.watch('partner_id')]);

  useEffect(() => {
    if (invoiceId) {
      getInvoice(invoiceId);
    }

    return () => {
      resetInvoice();
    };
  }, [invoiceId, getInvoice, resetInvoice]);

  useEffect(() => {
    if (invoice && company) {
      setUseCompanyLogo(invoice.logo === company.logo);
      setUseCompanySignature(invoice.signature === company.signature);

      form.reset({
        invoice_number: invoice.invoice_number,
        partner_id: invoice.partner_id,
        contact_id: invoice.contact_id || null,
        logo: invoice.logo || '',
        dateRange: {
          from: new Date(invoice.date),
          to: new Date(invoice.due_date),
        },
        currency: invoice.currency || 'rupiah',
        description: invoice.description || '',
        subtotal: invoice.subtotal,
        tax: invoice.tax,
        total: invoice.total,
        amount_due: invoice.amount_due,
        signature_name: invoice.signature_name || '',
        signature: invoice.signature || '',
        invoice_products: invoice.invoice_products || [
          {
            name: '',
            description: '',
            quantity: 0,
            price: 0,
            discount: 0,
            tax: 0,
            amount: 0,
            discount_type: 'percentage',
          },
        ],
      });
    }
  }, [invoice, company, form]);

  useEffect(() => {
    if (invoice?.partner_id) {
      setSelectedPartner(invoice.partner_id);
    }
  }, [invoice?.partner_id]);

  const closeRef = useRef<HTMLButtonElement>(null);

  // Function untuk close dialog yang akan di-pass ke FormPartner
  const handleCloseDialog = () => {
    closeRef.current?.click();
  };

  return (
    <LayoutAdmin header="Invoice">
      <div className="flex gap-4 items-center">
        <button
          type="button"
          className="flex items-center gap-1 text-xs md:text-base cursor-pointer font-medium text-secondary"
          onClick={navigateBack}
        >
          <ChevronLeft size={16} />
          Back
        </button>
        <div className="w-2 h-2 rounded-full bg-slate-100" />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href="/invoice" className="text-xs md:text-base">
                Sales Invoice
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-xs md:text-base">Edit Sales Invoice</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
      <p className="md:text-xl text-base font-medium">Edit Sales Invoice</p>
      {loading ? (
        <div className="flex justify-center items-center h-full gap-2">
          <LoaderCircle className="animate-spin" />
          <p>Loading invoice data...</p>
        </div>
      ) : (
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="flex flex-col md:flex-row gap-4">
              {/* Logo Input */}
              <div className="flex flex-col gap-3">
                <FormLabel>
                  Logo <span className="text-red-600">*</span>
                </FormLabel>
                <div className="border border-border rounded-md p-2 w-max h-max">
                  {useCompanyLogo && company?.logo ? (
                    <>
                      <img src={company?.logo} alt="Logo" className="w-36 h-36 md:w-60 md:h-60 rounded-md" />
                      <FormField
                        name="logo" // Nama field
                        control={form.control} // Kontrol dari useForm
                        render={({ field }) => (
                          <FormItem className="hidden">
                            <Input id="logo" {...field} value={company?.logo} />
                          </FormItem>
                        )}
                      />
                    </>
                  ) : (
                    <FileUploadSimple setValue={form.setValue} imageFieldName="logo" form={form} />
                  )}
                </div>
                {company?.logo && (
                  <div className="flex items-center space-x-2 ml-2">
                    <Checkbox id="useCompanyLogo" checked={useCompanyLogo} onCheckedChange={handleUseCompanyLogo} />
                    <label
                      htmlFor="useCompanyLogo"
                      className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                      Use company logo
                    </label>
                  </div>
                )}
              </div>
              {/* Form Detail Invoice */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
                <div className="flex flex-col gap-4">
                  <FormField
                    name="invoice_number" // Nama field
                    control={form.control} // Kontrol dari useForm
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel htmlFor="invoice_number">
                          Invoice No. <span className="text-red-600">*</span>
                        </FormLabel>
                        <Input id="invoice_number" placeholder="Enter Invoice Number..." {...field} />
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-4">
                  <FormField
                    name="currency" // Nama field
                    control={form.control} // Kontrol dari useForm
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Currency</FormLabel>
                        <Select onValueChange={field.onChange} defaultValue={field.value}>
                          <FormControl>
                            <SelectTrigger>
                              <SelectValue placeholder="Select currency" />
                            </SelectTrigger>
                          </FormControl>
                          <SelectContent>
                            <SelectItem value="rupiah">Rupiah</SelectItem>
                          </SelectContent>
                        </Select>
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-4 md:col-span-2">
                  <FormField
                    control={form.control}
                    name="dateRange"
                    render={({ field }) => (
                      <FormItem className="flex flex-col">
                        <FormLabel>Start and End Date</FormLabel>
                        <Popover modal>
                          <PopoverTrigger asChild>
                            <Button
                              id="date"
                              variant="outline"
                              className={cn(
                                'w-full justify-start text-left font-normal',
                                !field.value.from && 'text-muted-foreground',
                              )}
                            >
                              <CalendarIcon className="mr-2 h-4 w-4" />
                              {field.value.from ? (
                                field.value.to ? (
                                  <>
                                    {format(field.value.from, 'LLL dd, y')} - {format(field.value.to, 'LLL dd, y')}
                                  </>
                                ) : (
                                  format(field.value.from, 'LLL dd, y')
                                )
                              ) : (
                                <span>Pick a date</span>
                              )}
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent className="w-auto p-0" align="center">
                            <Calendar
                              initialFocus
                              mode="range"
                              defaultMonth={field.value.from}
                              selected={{
                                from: field.value.from!,
                                to: field.value.to,
                              }}
                              onSelect={field.onChange}
                              numberOfMonths={2}
                            />
                          </PopoverContent>
                        </Popover>
                        <FormDescription>Select the start and end date</FormDescription>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
                <div className="flex flex-col gap-4">
                  <FormField
                    control={form.control}
                    name="partner_id"
                    render={({ field }) => (
                      <FormItem className="flex flex-col">
                        <FormLabel>
                          Partner <span className="text-red-600">*</span>
                        </FormLabel>
                        <Popover>
                          <PopoverTrigger asChild>
                            <FormControl>
                              <Button
                                variant="outline"
                                role="combobox"
                                className={cn('justify-between', !field.value && 'text-muted-foreground')}
                              >
                                {field.value
                                  ? partners?.find((p) => p.partner_id === field.value)?.name
                                  : 'Select partner'}
                                <ChevronsUpDown className="opacity-50" />
                              </Button>
                            </FormControl>
                          </PopoverTrigger>
                          <PopoverContent className="p-0">
                            <Command>
                              <CommandInput placeholder="Search partner..." className="h-9" />
                              <CommandList>
                                <CommandEmpty>No partner found.</CommandEmpty>
                                <CommandGroup>
                                  {partners?.map((p) => (
                                    <CommandItem
                                      value={p.name}
                                      key={p.partner_id}
                                      onSelect={() => {
                                        form.setValue('partner_id', p?.partner_id as string);
                                        setSelectedPartner(p?.partner_id as string);
                                      }}
                                    >
                                      {p.name}
                                      <Check
                                        className={cn(
                                          'ml-auto',
                                          p.partner_id === field.value ? 'opacity-100' : 'opacity-0',
                                        )}
                                      />
                                    </CommandItem>
                                  ))}
                                </CommandGroup>
                              </CommandList>
                            </Command>
                          </PopoverContent>
                        </Popover>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <Dialog>
                    <DialogTrigger className="w-max ml-auto">
                      <Button variant="orangeOutline" className="w-max ml-auto" type="button">
                        Create New Partner
                      </Button>
                    </DialogTrigger>
                    <DialogContent className="w-[calc(100dvw-32px)] md:w-full rounded-lg">
                      <FormPartner onSuccess={handleCloseDialog} />
                      <DialogClose ref={closeRef} className="hidden" type="button" />
                    </DialogContent>
                  </Dialog>
                </div>
                <div className="flex flex-col gap-4">
                  <FormField
                    control={form.control}
                    name="contact_id"
                    render={({ field }) => (
                      <FormItem className="flex flex-col">
                        <FormLabel>Contact Person</FormLabel>
                        <Popover>
                          <PopoverTrigger asChild>
                            <FormControl>
                              <Button
                                variant="outline"
                                role="combobox"
                                className={cn('justify-between', !field.value && 'text-muted-foreground')}
                              >
                                {field.value
                                  ? contacts?.find((contact) => contact.contact_id === field.value)?.name
                                  : 'Select contact'}
                                <ChevronsUpDown className="opacity-50" />
                              </Button>
                            </FormControl>
                          </PopoverTrigger>
                          <PopoverContent className="p-0">
                            <Command>
                              <CommandInput placeholder="Search contact..." className="h-9" />
                              <CommandList>
                                <CommandEmpty>No contact found.</CommandEmpty>
                                <CommandGroup>
                                  {contacts
                                    ?.filter((contact) => selectedPartner === contact.partner_id)
                                    .map((contact) => (
                                      <CommandItem
                                        value={contact.name}
                                        key={contact.contact_id}
                                        onSelect={() => {
                                          form.setValue('contact_id', contact.contact_id ?? null);
                                        }}
                                      >
                                        {contact.name}
                                        <Check
                                          className={cn(
                                            'ml-auto',
                                            contact.contact_id === field.value ? 'opacity-100' : 'opacity-0',
                                          )}
                                        />
                                      </CommandItem>
                                    ))}
                                </CommandGroup>
                              </CommandList>
                            </Command>
                          </PopoverContent>
                        </Popover>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </div>
              </div>
            </div>
            <ProductListForm form={form} />
            <div className="flex md:gap-8 gap-4">
              <div className="flex flex-col">
                <div className="flex flex-col gap-2 mb-4">
                  <div className="flex gap-1 items-center">
                    <p>Signature and Stamp (Optional)</p>
                    <HoverCard>
                      <HoverCardTrigger>
                        <BadgeInfo className="w-4 h-4 md:w-6 md:h-6" />
                      </HoverCardTrigger>
                      <HoverCardContent>You can upload your signature in Settings</HoverCardContent>
                    </HoverCard>
                  </div>
                  <div className="flex flex-col gap-3">
                    <div className="border border-border rounded-md p-2 w-max h-max">
                      {useCompanySignature && company?.signature ? (
                        <>
                          <img
                            src={company?.signature}
                            alt="Signature"
                            className="w-36 h-36 md:w-60 md:h-60 rounded-md"
                          />
                          <FormField
                            name="signature" // Nama field
                            control={form.control} // Kontrol dari useForm
                            render={({ field }) => (
                              <FormItem className="hidden">
                                <Input id="signature" {...field} value={company?.signature} />
                              </FormItem>
                            )}
                          />
                        </>
                      ) : (
                        <FileUploadSimple setValue={form.setValue} imageFieldName="signature" form={form} />
                      )}
                    </div>
                    {company?.signature && (
                      <div className="flex items-center space-x-2 ml-2">
                        <Checkbox
                          id="useCompanySignature"
                          checked={useCompanySignature}
                          onCheckedChange={handleUseCompanySignature}
                        />
                        <label
                          htmlFor="useCompanySignature"
                          className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                          Use company signature
                        </label>
                      </div>
                    )}
                  </div>
                </div>
                <FormField
                  name="signature_name" // Nama field
                  control={form.control} // Kontrol dari useForm
                  render={({ field }) => (
                    <FormItem>
                      <Input id="signature_name" placeholder="Signature Name" {...field} />
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
              <FormField
                name="description"
                control={form.control}
                render={({ field }) => (
                  <FormItem>
                    <FormLabel className="flex gap-1 items-center">
                      <p>Description</p>
                      <HoverCard>
                        <HoverCardTrigger>
                          <BadgeInfo className="w-4 h-4 md:w-6 md:h-6" />
                        </HoverCardTrigger>
                        <HoverCardContent>Special instruction or message to the client</HoverCardContent>
                      </HoverCard>
                    </FormLabel>
                    <ReactQuill
                      theme="bubble"
                      placeholder="Payment instruction, thanky-you note, etc."
                      className={`${
                        form.formState.errors.description ? 'border-red-500' : ''
                      } min-w-40 md:min-w-96 max-w-80 min-h-32 rounded-md border border-neutral-200`}
                      {...field}
                      onChange={(content) => field.onChange(content)}
                    />
                  </FormItem>
                )}
              />
            </div>
            <div className="flex justify-end items-center gap-2 w-full">
              <Button type="submit" className="mt-4 btn-primary" disabled={loading}>
                {loading ? 'Updating...' : 'Update'}
              </Button>
              <Button
                variant="outline"
                type="button"
                className="mt-4 btn-primary"
                onClick={() => navigate(`/invoice/view/${invoice?.invoice_id}`)}
              >
                Cancel
              </Button>
            </div>
          </form>
        </Form>
      )}
    </LayoutAdmin>
  );
}
